import { render, staticRenderFns } from "./searchNeig.vue?vue&type=template&id=12a07796"
import script from "./searchNeig.vue?vue&type=script&lang=js"
export * from "./searchNeig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports